"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asOfDate = void 0;
const asOfDate = (date) => new Date(date).toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    minute: undefined,
    hour: undefined
}); // MM/dd/yyyy
exports.asOfDate = asOfDate;
